module.exports = __webpack_public_path__ + "img/home-slider3.bd002f3d.jpg";